import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card, Row, Col, Button, Input, Space, Modal, Switch, Tag, Popconfirm } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import _ from "lodash";
import { ProTable } from "@ant-design/pro-components";
import { faBinoculars, faCopy, faEnvelope, faTrash } from "@fortawesome/free-solid-svg-icons";

function EmailOutreach(props) {
  const table_columns = [
    {
      title: "Email Campaign Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (value) => {
        if (value === "preparing") return <Tag color="geekblue">{_.startCase(value)}</Tag>;
        if (value === "sent") return <Tag color="green">{_.startCase(value)}</Tag>;
        return <Tag>{_.startCase(value)}</Tag>;
      },
    },
    {
      title: "Email Subject",
      dataIndex: "email_subject",
      key: "email_subject",
    },
    {
      title: "Date Created",
      dataIndex: "created_at",
      key: "created_at",
      render: (value) => props.MakeDateTimeReadable(value),
    },
    {
      title: "Date Sent",
      dataIndex: "sent_at",
      key: "sent_at",
      render: (value) => (value !== "-" ? props.MakeDateTimeReadable(value) : "Not Yet Sent"),
    },
    {
      title: "Actions",
      align: "right",
      dataIndex: "id",
      key: "id",
      render: (text, row) => (
        <Space>
          <Link to={"/email-campaigns/" + row.tag}>
            <Button type="primary" size="small">
              <FontAwesomeIcon icon={faBinoculars} size="1x" className="mr-1" />
              Edit / View Campaign
            </Button>
          </Link>
          <Button
            size="small"
            onClick={() => {
              setCopyModalProps({ open: true, name: row.name + " (COPY)", copy_id: row.id });
            }}
          >
            <FontAwesomeIcon icon={faCopy} size="1x" className="mr-1" />
            Copy Campaign
          </Button>

          {row?.deleted_at ? (
            <Popconfirm
              okText="Restore"
              title="Are you sure you want to restore this campaign?"
              onConfirm={() => {
                RestoreCampaign(row?.id);
              }}
            >
              <Button primary type="dashed" size="small">
                <FontAwesomeIcon icon={faTrash} size="1x" className="mr-1" />
                Restore Campaign
              </Button>
            </Popconfirm>
          ) : (
            <Popconfirm
              icon={
                <QuestionCircleOutlined
                  style={{
                    color: "red",
                  }}
                />
              }
              okText="Delete"
              title="Are you sure you want to delete this campaign?"
              onConfirm={() => {
                DeleteCampaign(row?.id);
              }}
            >
              <Button danger size="small">
                <FontAwesomeIcon icon={faTrash} size="1x" className="mr-1" />
                Delete Campaign
              </Button>
            </Popconfirm>
          )}
        </Space>
      ),
    },
  ];
  const navigate = useNavigate();
  const [tableData, setTableData] = useState([]);
  const [tableSearch, setTableSearch] = useState(null);
  const [addModalProps, setAddModalProps] = useState({ open: false, name: "" });
  const [previewModalProps, setPreviewModalProps] = useState({ open: false, content: "" });
  const [copyModalProps, setCopyModalProps] = useState({ open: false, name: "" });
  const [showDeleted, setShowDeleted] = useState(false);

  const GetEmailOutreach = async () => {
    let response = await props.AxiosRequest("/api/email-campaigns/read/ssp", { show_deleted: showDeleted });
    setTableData(
      response.data.email_campaigns.map((m) => {
        return { ...m, key: m.id };
      }),
    );
  };

  const AddCampaign = async () => {
    if (addModalProps?.name.length === 0) return props.MakeNotification("warning", "Please enter a campaign name before creating the campaign.");
    if (addModalProps?.is_advertisement === 0 || addModalProps?.is_advertisement === false)
      return props.MakeNotification("warning", "At this moment FirmTamer does not support sending out emails that are classified as advertisements.");
    let response = await props.AxiosRequest("/api/email-campaigns/create", { name: addModalProps?.name });
    if (response?.data?.tag) {
      navigate("/email-campaigns/" + response?.data?.tag);
    }
  };
  const CopyCampaign = async () => {
    if (copyModalProps?.name.length === 0) return props.MakeNotification("warning", "Please enter a campaign name before creating the campaign.");
    if (copyModalProps?.is_advertisement === 0 || copyModalProps?.is_advertisement === false)
      return props.MakeNotification("warning", "At this moment FirmTamer does not support sending out emails that are classified as advertisements.");
    let response = await props.AxiosRequest("/api/email-campaigns/copy", { name: copyModalProps?.name, source_id: copyModalProps?.copy_id });
    if (response?.data?.tag) {
      navigate("/email-campaigns/" + response?.data?.tag);
    }
  };
  const DeleteCampaign = async (id) => {
    await props.AxiosRequest("/api/email-campaigns/delete", { id });
    GetEmailOutreach();
  };
  const RestoreCampaign = async (id) => {
    await props.AxiosRequest("/api/email-campaigns/restore", { id });
    GetEmailOutreach();
  };

  const SendTestEmail = async () => {
    // if (addModalProps?.name.length === 0) return props.MakeNotification("warning", "Please enter a campaign name before creating the campaign.");
    let response = await props.AxiosRequest("/api/emails/send-test", { name: addModalProps?.name });
  };

  useEffect(() => {
    GetEmailOutreach();
  }, []);
  useEffect(() => {
    GetEmailOutreach();
  }, [showDeleted]);

  return (
    <main className="content">
      <div className="container-fluid">
        <div className="header">
          <h1 className="header-title">Email Outreach</h1>
        </div>
        <Row>
          <Card
            title="Email Correspondence"
            extra={
              <Space>
                <Button
                  type="primary"
                  onClick={() => {
                    setAddModalProps({ ...addModalProps, open: true });
                  }}
                >
                  <FontAwesomeIcon icon={faEnvelope} className="mr-1" /> Add New Email Campaign
                </Button>
                {/* <Button
                  type="primary"
                  onClick={() => {
                    SendTestEmail();
                  }}
                >
                  <FontAwesomeIcon icon={faEnvelope} className="mr-1" /> Send Email
                </Button> */}
              </Space>
            }
            style={{
              width: "100%",
            }}
            bodyStyle={{ paddingLeft: "0px", paddingRight: "0px", paddingTop: "2px" }}
          >
            <Row>
              <Col span={24}>
                <ProTable
                  className="pro-table-striped"
                  highlightOnHover
                  pagination={{
                    // total: tableData.length,
                    hideOnSinglePage: true,
                    showTotal: (total, range) => {
                      return `Showing ${range[0]} to ${range[1]} of ${total}` + (tableSearch?.length ? ` (filtered)` : ``) + ` entries`;
                    },
                  }}
                  // pagination
                  paginationComponentOptions={{
                    selectAllRowsItem: true,
                  }}
                  pointerOnHover
                  responsive
                  striped
                  subHeaderAlign="right"
                  subHeaderWrap
                  columns={table_columns}
                  search={false}
                  toolbar={{
                    title: "  ",
                    search: (
                      <Input
                        placeholder="Search..."
                        value={tableSearch}
                        allowClear
                        onChange={(change) => {
                          setTableSearch(change.target.value);
                        }}
                      />
                    ),
                  }}
                  options={false}
                  dataSource={tableData}
                  params={{ search: tableSearch }}
                  request={GetEmailOutreach}
                  debounceTime={500}
                />
              </Col>
              <Col span={23} className="text-right">
                <label className="col-form-label-sm w-100">Show Deleted Campaigns?</label>
                <Switch
                  value={showDeleted}
                  onChange={(e) => {
                    setShowDeleted(e);
                  }}
                />
              </Col>
            </Row>
          </Card>
        </Row>
      </div>
      <Modal
        title="Create A New Campaign"
        open={addModalProps?.open}
        onCancel={() => {
          setAddModalProps({ open: false, name: "" });
        }}
        onClose={() => {
          setAddModalProps({ open: false, name: "" });
        }}
        okText="Create Campaign"
        onOk={AddCampaign}
      >
        <Row gutter={[8, 8]}>
          <Col span={24}>
            <label className="col-form-label-sm">Campaign Name *</label>
            <Input
              value={addModalProps?.name}
              showCount
              maxLength={64}
              onChange={(e) => {
                setAddModalProps({ ...addModalProps, name: e.target.value });
              }}
            />
          </Col>
          <Col span={24}>
            <label className="col-form-label-sm w-100">Is This Campaign An Advertisment? *</label>
            <Switch
              value={addModalProps?.is_advertisement}
              onChange={(e) => {
                setAddModalProps({ ...addModalProps, is_advertisement: e });
              }}
            />
          </Col>
        </Row>
      </Modal>

      <Modal
        width={1200}
        title={previewModalProps?.name ? "Preview Email From " + previewModalProps?.name : "Preview Email From Campaign"}
        open={previewModalProps?.open}
        onCancel={() => {
          setPreviewModalProps({ open: false, name: "" });
        }}
        onClose={() => {
          setPreviewModalProps({ open: false, name: "" });
        }}
        footer={null}
        onOk={AddCampaign}
      >
        <Row gutter={[8, 8]}>
          <Col span={24}>
            <label className="col-form-label-sm">Email Subject</label>
            <Input readOnly value={previewModalProps?.email_subject} />
          </Col>
          <Col span={12}>
            <label className="col-form-label-sm">From: </label>
            <Input readOnly value={previewModalProps?.email_subject} />
          </Col>
          <Col span={12}>
            <label className="col-form-label-sm">Reply-To: </label>
            <Input readOnly value={previewModalProps?.email_subject} />
          </Col>
          <Col span={24}>
            <div dangerouslySetInnerHTML={{ __html: previewModalProps?.email_content }}></div>
          </Col>
        </Row>
      </Modal>

      <Modal
        title="Copy Campaign"
        open={copyModalProps?.open}
        onCancel={() => {
          setCopyModalProps({ open: false, name: "" });
        }}
        onClose={() => {
          setCopyModalProps({ open: false, name: "" });
        }}
        okText="Create Campaign"
        onOk={CopyCampaign}
      >
        <Row gutter={[8, 8]}>
          <Col span={24}>
            <label className="col-form-label-sm">New Campaign Name *</label>
            <Input
              value={copyModalProps?.name}
              showCount
              maxLength={64}
              onChange={(e) => {
                setCopyModalProps({ ...copyModalProps, name: e.target.value });
              }}
            />
          </Col>
          <Col span={24}>
            <label className="col-form-label-sm w-100">Is This Campaign An Advertisment? *</label>
            <Switch
              value={copyModalProps?.is_advertisement}
              onChange={(e) => {
                setCopyModalProps({ ...copyModalProps, is_advertisement: e });
              }}
            />
          </Col>
        </Row>
      </Modal>
    </main>
  );
}

export default EmailOutreach;
